// import React, { useEffect, useState, useMemo } from "react"
// import Select from "react-select"
// import {
//   Container,
//   Form,
//   Label,
//   Input,
//   ModalHeader,
//   ModalBody,
//   Button,
//   Table,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Modal,
// } from "reactstrap"
// import Breadcrumbs from "../../../components/Common/Breadcrumb"
// import { Link, useNavigate } from "react-router-dom"
// import {
//   useTable,
//   useSortBy,
//   usePagination,
//   useGlobalFilter,
// } from "react-table"
// import moment from "moment"
// import Loader from "pages/Separate/Loader"
// import Swal from "sweetalert2"
// import AccessDeniedPopup from "routes/AccessDeniedPopup"
// import CommonTable from "utils/CommonTable"
// import { hostingColumns } from "utils/columns/work/workColumns"
// import Pagination from "components/Common/Pagination"
// import "../../../assets/css/Work/projects.css"

// import {
//   fetchData,
//   fetchNodeData,
//   FetchNodePostData,
//   FetchNodePutData,
// } from "utils/common-fetchData"
// import secureLocalStorage from "react-secure-storage"
// import HostingModal, { calculateDueDate } from "./HostingModal"

// function TableContainer({
//   columns,
//   allData,
//   dataLength,
//   dueThisMonth,
//   handleSubmit,
//   locationOptions,
//   customerOptions,
//   projectOptions,
//   packageOptions,
//   setCustomerOption,
//   setProjectOptions,
//   allServicesOptions,
//   hostingDurations,
//   location,
//   setLocation,
//   customer,
//   setCustomer,
//   project,
//   setProject,
//   Package,
//   setPackage,
//   services,
//   setServices,
//   modal,
//   setModal,
//   isEdit,
//   setEdit,
//   isRenew,
//   setRenew,
//   dashElement,
// }) {
//   //   const [modal, setModal] = useState(false)
//   const navigate = useNavigate()
//   const [activeTab, setActiveTab] = useState(dashElement ? "CURRENT" : "ALL")

//   // tabs wise filter
//   const parseServices = services => {
//     try {
//       return JSON.parse(services)
//     } catch {
//       return []
//     }
//   }

//   const isSameMonth = (date, ref) =>
//     date.getMonth() === ref.getMonth() &&
//     date.getFullYear() === ref.getFullYear()

//   const isBetween = (date, start, end) => date >= start && date <= end

//   const filterHostingData = (allData, activeTab) => {
//     if (activeTab === "ALL") return allData

//     const today = new Date()
//     const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1)
//     const sixMonthsLater = new Date(
//       today.getFullYear(),
//       today.getMonth() + 6,
//       today.getDate()
//     )

//     return allData.filter(item => {
//       const services = parseServices(item.services)

//       return services.some(service => {
//         if (!service.dueDate) return false

//         const dueDate = new Date(service.dueDate)

//         switch (activeTab) {
//           case "CURRENT":
//             return isSameMonth(dueDate, today)

//           case "NEXT":
//             return isSameMonth(dueDate, nextMonth)

//           case "SIX_MONTHS":
//             return isBetween(dueDate, today, sixMonthsLater)

//           case "EXPIRED":
//             return dueDate < today

//           default:
//             return true
//         }
//       })
//     })
//   }

//   const data = useMemo(
//     () => filterHostingData(allData, activeTab),
//     [allData, activeTab]
//   )

//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     page,
//     state,
//     previousPage,
//     nextPage,
//     canPreviousPage,
//     canNextPage,
//     gotoPage,
//     setPageSize,
//     pageOptions,
//     setGlobalFilter,
//     prepareRow,
//   } = useTable(
//     {
//       columns,
//       data,
//       initialState: {
//         sortBy: [
//           {
//             id: "id",
//             desc: true,
//           },
//         ],
//       },
//     },
//     useGlobalFilter,
//     useSortBy,
//     usePagination
//   )

//   const { pageIndex, pageSize, globalFilter } = state
//   useEffect(() => {
//     setPageSize(50)
//   }, [setPageSize])

//   const TABS = [
//     { key: "ALL", label: "All" },
//     { key: "CURRENT", label: "Current", title: "Expiring current month" },
//     { key: "NEXT", label: "Next", title: "Expiring next month" },
//     {
//       key: "SIX_MONTHS",
//       label: "In Six months",
//       title: "Expiring upcoming 6 months",
//     },
//     { key: "EXPIRED", label: "Expired" },
//   ]

//   return (
//     <>
//       <Row className="mb-4 align-items-center">
//         <Col md={5} className="pr-0">
//           <div className="d-flex justify-content-between align-items-center">
//             {/* Tabs */}
//             <div className="d-flex justify-content-start w-100 align-items-center gap-3 mb-3">
//               {TABS.map(tab => (
//                 <button
//                   key={tab.key}
//                   title={tab.title}
//                   className={`py-1 px-3 rounded fs-6  border-0 proposal-status w-auto ${
//                     activeTab === tab.key
//                       ? "text-white bg-purple fw-semibold"
//                       : "text-purple"
//                   }`}
//                   onClick={() => setActiveTab(tab.key)}
//                 >
//                   {/* {activeTab === tab.key && <h4>{data.length}</h4>} */}
//                   {tab.label}{" "}
//                   {activeTab === tab.key && <span>: {data.length}</span>}{" "}
//                 </button>
//               ))}
//             </div>
//           </div>
//           {/* {!dashElement ? (
//           ) : (
//             <h4>Hosting</h4>
//           )} */}
//         </Col>
//         <Col
//           md={7}
//           className="d-flex align-items-center justify-content-end pl-0"
//         >
//           <div>
//             <select
//               className="s me-4 form-select"
//               style={{ width: "100px" }}
//               value={pageSize}
//               onChange={e => setPageSize(Number(e.target.value))}
//             >
//               {[10, 25, 50, 100].map(size => (
//                 <option key={size} value={size}>
//                   Show {size}
//                 </option>
//               ))}
//             </select>
//           </div>
//           <div className="me-4 mt-10">
//             <div className="search-box">
//               <div className="position-relative">
//                 <label htmlFor="search-bar-0" className="search-label">
//                   <span id="search-bar-0-label" className="sr-only">
//                     Search this table
//                   </span>
//                   <input
//                     onChange={e => setGlobalFilter(e.target.value)}
//                     id="search-bar-0"
//                     type="text"
//                     className="s form-control rounded"
//                     placeholder="Search..."
//                     value={globalFilter || ""}
//                   />
//                 </label>
//                 <i className="bx bx-search-alt search-icon"></i>
//               </div>
//             </div>
//           </div>
//           <div className="text-md-end">
//             {!dashElement && (
//               <>
//                 <Link
//                   onClick={() => setModal(true)}
//                   className="s btn text-white me-2 btn-save btn-label"
//                 >
//                   <i className="fas fa-plus me-2 icon-size label-icon"></i>Add
//                   Hosting
//                 </Link>
//                 <button
//                   onClick={() => navigate(-1)}
//                   className="s btn btn-red btn-label"
//                 >
//                   <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                   CANCEL
//                 </button>
//               </>
//             )}
//           </div>
//         </Col>
//       </Row>
//       <div className="position-relative">
//         <CommonTable
//           getTableProps={getTableProps}
//           headerGroups={headerGroups}
//           getTableBodyProps={getTableBodyProps}
//           page={page}
//           prepareRow={prepareRow}
//         />
//       </div>

//       <Row className="justify-content-md-end justify-content-center align-items-center">
//         <Pagination
//           gotoPage={gotoPage}
//           previousPage={previousPage}
//           canPreviousPage={canPreviousPage}
//           nextPage={nextPage}
//           canNextPage={canNextPage}
//           pageIndex={pageIndex}
//           pageOptions={pageOptions}
//         />
//       </Row>

//       <HostingModal
//         modal={modal}
//         setModal={setModal}
//         locationOptions={locationOptions}
//         customerOptions={customerOptions}
//         projectOptions={projectOptions}
//         packageOptions={packageOptions}
//         setCustomerOption={setCustomerOption}
//         setProjectOptions={setProjectOptions}
//         allServicesOptions={allServicesOptions}
//         hostingDurations={hostingDurations}
//         handleSubmit={handleSubmit}
//         location={location}
//         setLocation={setLocation}
//         customer={customer}
//         setCustomer={setCustomer}
//         project={project}
//         setProject={setProject}
//         Package={Package}
//         setPackage={setPackage}
//         services={services}
//         setServices={setServices}
//         isEdit={isEdit}
//         setEdit={setEdit}
//         isRenew={isRenew}
//         setRenew={setRenew}
//       />
//     </>
//   )
// }

// const HostingIndexPage2 = ({ dashElement = false }) => {
//   const [modal, setModal] = useState(false)
//   const [isEdit, setEdit] = useState(false)
//   const [isRenew, setRenew] = useState(false)
//   const [isLoading, setLoading] = useState(false)
//   const [data, setData] = useState([])
//   const [allData, setAllData] = useState([])
//   const [locationOptions, setLocationOption] = useState([])
//   const [customerOptions, setCustomerOption] = useState([])
//   const [projectOptions, setProjectOptions] = useState([])
//   const [packageOptions, setPackageOptions] = useState([])
//   const [allServicesOptions, setAllServicesOptions] = useState([])
//   const [hostingDurations, setHostingDurations] = useState([])

//   const [allCustomers, setAllCustomer] = useState([])
//   const [location, setLocation] = useState(null)
//   const [customer, setCustomer] = useState(null)
//   const [project, setProject] = useState(null)
//   const [Package, setPackage] = useState(null)
//   const [services, setServices] = useState([])

//   const [viewModal, setViewModal] = useState(false)
//   const [renewalLogs, setRenewalLogs] = useState(false)
//   const [viewData, setViewData] = useState(null)
//   const [currencyOptions, setCurrencyOptions] = useState([])

//   // getting initial Datas
//   useEffect(() => {
//     ;(async () => {
//       await getHostingData()
//       await fetchProjectData()
//       await getPackageData()
//     })()
//   }, [])

//   useEffect(() => {
//     ;(async () => {
//       const response = await fetchData(
//         setLoading,
//         "currency",
//         secureLocalStorage?.getItem("auth_token")
//       )
//       if (response?.success) {
//         const options = response?.data?.currency?.map(c => ({
//           label: c.currency,
//           value: c.currency,
//           symbol: c.symbol,
//         }))
//         setCurrencyOptions(options)
//       }
//     })()
//   }, [])

//   const getHostingData = async () => {
//     const response = await fetchNodeData(
//       setLoading,
//       "hostings",
//       secureLocalStorage?.getItem("auth_token")
//     )

//     setData(response.data)
//     setAllData(response.data)
//     // setDataLength(response.data.length)
//     // setDueThisMonth(getHostingsDueThisMonth(response.data))
//   }

//   const fetchProjectData = async () => {
//     try {
//       const res = await fetchData(
//         setLoading,
//         "projectRelatedData",
//         secureLocalStorage.getItem("auth_token")
//       )
//       if (res?.success) {
//         const { location, customer = [] } = res.data
//         const createOptions = (items, label, value) => {
//           return items
//             ?.filter(i => i.id !== 2)
//             ?.map(item => ({ label: item?.[label], value: item?.[value] }))
//         }
//         //         const createOptions = (items, label, value) => {
//         //   return items?.map(item => ({
//         //     label: item?.[label],
//         //     value: item?.[value],
//         //   }))
//         // }
//         const locs = createOptions(location, "location", "id")
//         setLocationOption(locs || [])
//         setLocation(locs[0] || null)
//         console.log("customer", customer)
//         setAllCustomer(
//           customer
//             ?.filter(i => i.trash == 0)
//             ?.map(item => ({
//               label: item.company || "",
//               value: item.id || "",
//               location: item.location || "",
//             }))
//         )
//       }
//     } catch (error) {
//       console.error("Error fetching project data:", error)
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to load project data. Please try again.",
//       })
//     }
//   }

//   const getPackageData = async () => {
//     try {
//       const packageResponse = await fetchNodeData(
//         null,
//         "hostingPackageOption",
//         secureLocalStorage?.getItem("auth_token")
//       )

//       if (packageResponse.success && packageResponse.data) {
//         const packageOptions = packageResponse.data
//           .filter(pkg => pkg.trash === 0)
//           .map(pkg => ({
//             value: pkg.id,
//             label: pkg.package_name,
//             services: pkg.services,
//           }))
//         setPackageOptions(packageOptions)
//       } else {
//         setPackageOptions([])
//         Swal.fire({
//           icon: "warning",
//           title: "No Packages",
//           text: "No packages found.",
//         })
//       }

//       const servicesResponse = await fetchNodeData(
//         null,
//         "hostingService/service/get",
//         secureLocalStorage?.getItem("auth_token")
//       )

//       if (servicesResponse.success && servicesResponse.data) {
//         const servicesOptions = servicesResponse.data
//           .filter(srv => srv.trash === 0)
//           .map(srv => ({
//             value: srv.id,
//             label: srv.service_name,
//             price: parseFloat(srv.price),
//             service_box: srv.service_box,
//           }))
//         setAllServicesOptions(servicesOptions)
//       }

//       const durationResponse = await FetchNodePostData(
//         null,
//         "hostingOptions/duration",
//         secureLocalStorage?.getItem("auth_token"),
//         {}
//       )

//       if (durationResponse.data?.success && durationResponse.data?.data) {
//         const durationOptions = durationResponse.data?.data
//           ?.filter(srv => srv.trash === 0)
//           ?.map(srv => ({
//             value: srv.duration,
//             label: `${srv.duration} ${srv.month_duration}`,
//           }))

//         console.log("durationOptions", durationOptions)
//         setHostingDurations(durationOptions)
//       }
//     } catch (error) {
//       console.error(
//         "Error fetching package, duration, or services data:",
//         error
//       )
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to load data. Please try again.",
//       })
//     }
//   }

//   useEffect(() => {
//     if (location?.value) {
//       setCustomerOption(
//         allCustomers.filter(item => item.location == location.value)
//       )
//     }
//   }, [location])

//   useEffect(() => {
//     if (customer?.value) {
//       fetchProjects(customer?.value)
//     }
//   }, [customer])

//   const fetchProjects = async customerId => {
//     try {
//       const response = await FetchNodePostData(
//         setLoading,
//         "hostingOptions/projects",
//         secureLocalStorage?.getItem("auth_token"),
//         { customer: customerId }
//       )

//       if (response.data.success) {
//         const options = response.data.data
//           ?.filter(item => item.trash === 0)
//           .map(item => ({
//             value: item.id,
//             label: item.project_name,
//           }))
//         setProjectOptions(options)
//         return options
//       }
//     } catch (error) {
//       console.error("Error fetching projects:", error)
//       setProjectOptions([])
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to load projects. Please try again.",
//       })
//     }
//   }

//   async function onViewPermission(data) {
//     const response = await fetchNodeData(
//       setLoading,
//       `hostingRenewLogs/${data.id}`,
//       secureLocalStorage?.getItem("auth_token")
//     )
//     setViewData(data)
//     setRenewalLogs(response.data)
//     setViewModal(true)
//   }

//   async function onEditPermission(data) {
//     setEdit(data.id)
//     setLocation(locationOptions.find(item => item.value == data.location))
//     setCustomer(allCustomers.find(item => item.value == data.customer_name))
//     if (data.customer_name) {
//       const projects = await fetchProjects(data.customer_name)
//       setProject(projects?.find(item => item.value == data.project_name))
//     }
//     setPackage(
//       packageOptions?.find(item => item.value == data?.package?.packageId)
//     )
//     console.log("dataaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa", data)
//     setServices(JSON.parse(data.services))
//     setModal(true)
//   }

//   function onRenewPermission(data) {
//     onEditPermission(data)
//     setRenew(true)
//     setModal(true)
//   }

//   const totalPrice = useMemo(
//     () => services?.reduce((acc, curr) => acc + (Number(curr.price) || 0), 0),
//     [services]
//   )

//   const totalBase = useMemo(
//     () =>
//       services?.reduce((acc, curr) => acc + (Number(curr.basePrice) || 0), 0),
//     [services]
//   )

//   const handleSubmit = async (e, service_id) => {
//     if (e) e.preventDefault()
//     const submitDatasssss = {
//       location_id: location?.value,
//       customer_id: customer?.value,
//       project_id: project ? project.value : null,
//       package_id: Package?.value,
//       services: JSON.stringify(services),
//       total_price: totalPrice?.toFixed(2),
//       total_base_price: totalBase?.toFixed(2),
//       ...(service_id ? { service_id } : {}),
//     }

//     console.log("submitdata", submitDatasssss)

//     if (
//       !location?.value ||
//       !customer?.value ||
//       // !project?.value ||
//       !Package?.value ||
//       services?.some(
//         srv =>
//           !srv.service ||
//           !srv.renewalDuration ||
//           !srv.startDate ||
//           (!srv.description && srv.service_box == "yes")
//       )
//     ) {
//       Swal.fire({
//         icon: "warning",
//         title: "Oops...",
//         text: "Please fill all required fields, including service details!",
//       })
//       return
//     }

//     const postServices = services.map(s => ({
//       id: s.id,
//       service: s.service,
//       description: s.description,
//       price: s.price,
//       basePrice: s.basePrice,
//       startDate: s.startDate,
//       dueDate: s.dueDate,
//       renewalDuration : s.renewalDuration,
//       currency: s.currency,
//       service_box: s.service_box,
//       isPackageService: s.isPackageService,
//     }))

//     const submitData = {
//       location_id: location?.value,
//       customer_id: customer?.value,
//       project_id: project ? project.value : null,
//       package_id: Package?.value,
//       services: JSON.stringify(postServices),
//       total_price: totalPrice?.toFixed(2),
//       total_base_price: totalBase?.toFixed(2),
//       ...(service_id ? { service_id } : {}),
//     }

//     // Compute dynamic start/end date for renewal message
//     const firstService = services.find(s => s.id == service_id)

//     // const startDateStr = firstService
//     //   ? moment(firstService.startDate).format("DD-MM-YYYY")
//     //   : "-"
//     // const endDateStr = firstService
//     //   ? moment(firstService.dueDate).format("DD-MM-YYYY")
//     //   : "-"
//     // const startDateStr = firstService?.startDate
//     // const endDateStr = calculateDueDate(
//     //   firstService?.startDate,
//     //   firstService?.renewalDuration
//     // )
// const startDateStr = firstService?.startDate
//   ? moment(firstService.startDate).format("DD-MM-YYYY")
//   : null

// const endDateStr = firstService?.startDate && firstService?.renewalDuration
//   ? moment(calculateDueDate(firstService.startDate, firstService.renewalDuration)).format("DD-MM-YYYY")
//   : null

//     const warningMsg = isRenew
//       ? `${startDateStr ? `You want to renew this service from\n${startDateStr} to ${endDateStr}?` : 'You really want to update?'}`
//       : isEdit
//       ? "You really want to update?"
//       : "You really want to add?"

//     swal({
//       title: "Are you sure?",
//       text: warningMsg,
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     }).then(async willDelete => {
//       if (willDelete) {
//         try {
//           let response
//           if (isEdit || isRenew) {
//             response = await FetchNodePutData(
//               setLoading,
//               "hostingOperations/edit",
//               isEdit,
//               submitData
//             )
//           } else {
//             response = await FetchNodePostData(
//               setLoading,
//               "hostingOperations/add",
//               secureLocalStorage?.getItem("auth_token"),
//               submitData
//             )
//           }
//           if (response.data.success) {
//             Swal.fire({
//               icon: "success",
//               title: "Success",
//               text: ` ${
//                 isRenew
//                   ? `Service${startDateStr ? ' Renewed' : 's updated'} `
//                   : isEdit
//                   ? "Hosting updated"
//                   : "Hosting added"
//               } successfully`,
//             })

//             setServices(postServices)

//             if (!isRenew) setModal(false)
//             getHostingData()
//           }
//         } catch (error) {
//           console.error("Error in handleSubmit:", error)
//           Swal.fire({
//             icon: "error",
//             title: "Error",
//             text: "Failed to add hosting. Please try again.",
//           })
//         }
//       }
//     })
//   }

//   const columns = useMemo(
//     () =>
//       hostingColumns(
//         onViewPermission,
//         onEditPermission,
//         onRenewPermission,
//         currencyOptions
//       ),
//     [allCustomers, packageOptions]
//   )

//   //   hostingDurations

//   return (
//     <>
//       {isLoading && <Loader />}
//       <Row>
//         <Col lg={12} className="p-0">
//           <Card>
//             <CardBody>
//               <div className="responsive-table">
//                 <TableContainer
//                   columns={columns}
//                   allData={allData || []}
//                   dataLength={7}
//                   dueThisMonth={1}
//                   locationOptions={locationOptions}
//                   customerOptions={customerOptions}
//                   projectOptions={projectOptions}
//                   packageOptions={packageOptions}
//                   setCustomerOption={setCustomerOption}
//                   setProjectOptions={setProjectOptions}
//                   allServicesOptions={allServicesOptions}
//                   hostingDurations={hostingDurations}
//                   handleSubmit={handleSubmit}
//                   location={location}
//                   setLocation={setLocation}
//                   customer={customer}
//                   setCustomer={setCustomer}
//                   project={project}
//                   setProject={setProject}
//                   Package={Package}
//                   setPackage={setPackage}
//                   services={services}
//                   setServices={setServices}
//                   modal={modal}
//                   setModal={setModal}
//                   isEdit={isEdit}
//                   setEdit={setEdit}
//                   isRenew={isRenew}
//                   setRenew={setRenew}
//                   dashElement={dashElement}
//                 />
//               </div>
//             </CardBody>
//           </Card>
//         </Col>
//       </Row>

//       <Modal
//         isOpen={viewModal}
//         toggle={() => setViewModal(false)}
//         size="xl"
//         centered
//         style={{ maxWidth: "95vw", width: "95vw" }}
//       >
//         <ModalHeader
//           toggle={() => {
//             setViewModal(false)
//             setViewData(null)
//           }}
//           className="text-purple"
//         >
//           Hosting Renewal Logs:{" "}
//           <span className="text-primary fw-bold">
//             {viewData ? viewData.customer : "Unknown Project"}
//           </span>
//         </ModalHeader>
//         <ModalBody>
//           <Table bordered hover responsive striped>
//             <thead>
//               <tr>
//                 <th className="text-center">Sr. No</th>
//                 <th className="text-center">Package</th>
//                 <th className="text-center">Package Price</th>
//                 <th className="text-center">Service</th>
//                 <th className="text-center">Start Date</th>
//                 <th className="text-center">Due Date</th>
//                 <th className="text-center">Renewed On</th>
//                 <th className="text-center">Renewal Duration</th>
//               </tr>
//             </thead>
//             <tbody>
//               {renewalLogs.length ? (
//                 renewalLogs.map((log, index) => (
//                   <tr key={log.id}>
//                     <td className="text-center">{index + 1}</td>
//                     <td className="text-center">{log.package_name}</td>
//                     <td className="text-center">
//                       {log.price
//                         ? log.price
//                             .split(",")
//                             .map(Number)
//                             .reduce((a, b) => a + b, 0)
//                         : 0}
//                     </td>
//                     <td className="text-center">{log.service}</td>
//                     <td className="text-center">
//                       {moment(log.start_date).format("DD-MM-YYYY")}
//                     </td>
//                     <td className="text-center">
//                       {moment(log.due_date).format("DD-MM-YYYY")}
//                     </td>
//                     <td className="text-center">
//                       {log.renew_date
//                         ? moment(log.renew_date).format("DD-MM-YYYY")
//                         : "--"}
//                     </td>
//                     <td className="text-center">
//                       {log.renew_duration || "--"}
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr className="text-center">
//                   <td colSpan={8}>No Renewal Logs Found</td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </ModalBody>
//       </Modal>
//     </>
//   )
// }

// export default HostingIndexPage2

import React, { useEffect, useState, useMemo } from "react";
import Select from "react-select";
import {
  Container,
  Form,
  Label,
  Input,
  ModalHeader,
  ModalBody,
  Button,
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import moment from "moment";
import Loader from "pages/Separate/Loader";
import Swal from "sweetalert2";
import AccessDeniedPopup from "routes/AccessDeniedPopup";
import CommonTable from "utils/CommonTable";
import { hostingColumns } from "utils/columns/work/workColumns";
import Pagination from "components/Common/Pagination";
import "../../../assets/css/Work/projects.css";

import {
  fetchData,
  fetchNodeData,
  FetchNodePostData,
  FetchNodePutData,
} from "utils/common-fetchData";
import secureLocalStorage from "react-secure-storage";
import HostingModal, { calculateDueDate } from "./HostingModal";
import configure from "configure";

function TableContainer({
  columns,
  allData,
  dataLength,
  dueThisMonth,
  handleSubmit,
  locationOptions,
  customerOptions,
  projectOptions,
  packageOptions,
  setCustomerOption,
  setProjectOptions,
  allServicesOptions,
  hostingDurations,
  location,
  setLocation,
  customer,
  setCustomer,
  project,
  setProject,
  Package,
  setPackage,
  services,
  setServices,
  modal,
  setModal,
  isEdit,
  setEdit,
  isRenew,
  setRenew,
  dashElement,
}) {
  //   const [modal, setModal] = useState(false)
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("CURRENT");
  console.log("locationOptions2: ", locationOptions);

  // tabs wise filter
  const parseServices = (services) => {
    try {
      return JSON.parse(services);
    } catch {
      return [];
    }
  };

  const isSameMonth = (date, ref) =>
    date.getMonth() === ref.getMonth() &&
    date.getFullYear() === ref.getFullYear();

  const isBetween = (date, start, end) => date >= start && date <= end;

  const filterHostingData = (allData, activeTab) => {
    if (activeTab === "ALL") return allData;

    const today = new Date();
    const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    const sixMonthsLater = new Date(
      today.getFullYear(),
      today.getMonth() + 6,
      today.getDate(),
    );

    return allData.filter((item) => {
      const services = parseServices(item.services);

      return services.some((service) => {
        if (!service.dueDate) return false;

        const dueDate = new Date(service.dueDate);

        switch (activeTab) {
          case "CURRENT":
            return isSameMonth(dueDate, today);

          case "NEXT":
            return isSameMonth(dueDate, nextMonth);

          case "SIX_MONTHS":
            return isBetween(dueDate, today, sixMonthsLater);

          case "EXPIRED":
            return dueDate < today;

          default:
            return true;
        }
      });
    });
  };

  const data = useMemo(
    () => filterHostingData(allData, activeTab),
    [allData, activeTab],
  );

  const defaultSort = useMemo(() => {
    if (activeTab === "ALL") {
      return [{ id: "id", desc: true }];
    } else {
      return [{ id: "dueDate", desc: false }];
    }
  }, [activeTab]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    setSortBy,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [{ id: "id", desc: true }],
      },
      autoResetSortBy: false,
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    if (activeTab === "ALL") {
      setSortBy([{ id: "id", desc: true }]);
    } else {
      setSortBy([{ id: "dueDate", desc: false }]);
    }
  }, [activeTab]);

  const { pageIndex, pageSize, globalFilter } = state;
  useEffect(() => {
    setPageSize(50);
  }, [setPageSize]);

  const TABS = [
    { key: "ALL", label: "All" },
    { key: "CURRENT", label: "Current Month", title: "Expiring current month" },
    { key: "NEXT", label: "Next Month", title: "Expiring next month" },
    {
      key: "SIX_MONTHS",
      label: "In Six month",
      title: "Expiring upcoming 6 months",
    },
    { key: "EXPIRED", label: "Expired" },
  ];
  console.log("data", data);
  // const getCountByTab = (tabKey) => {
  //   console.log("alldata",allData);
  //    console.log("data",data);
  //   if (tabKey === "all") return allData.length;

  //   return allData.filter(item => item.status === tabKey).length;
  // };

  return (
    <>
      <Row className="mb-4 align-items-center">
        <Col md={5} className="pr-0">
          <div className="d-flex justify-content-between align-items-center">
            {/* Tabs */}
            <div className="d-flex justify-content-start w-100 align-items-center gap-3 mb-3">
              {/* {TABS.map(tab => (              
                <button
                  key={tab.key}
                  title={tab.title}
                  className={`py-1 px-3 rounded fs-6  border-0 proposal-status w-auto ${
                    activeTab === tab.key
                      ? "text-white bg-purple fw-semibold"
                      : "text-purple"
                  }`}
                  onClick={() => setActiveTab(tab.key)}
                >
                  { <h4>{data.length}</h4>}
                  {tab.label}{" "}
                  {activeTab === tab.key && <span>: {data.length}</span>}{" "}
                </button>
              ))} */}
              {TABS.map((tab) => {
                const tabData = filterHostingData(allData, tab.key);

                return (
                  <button
                    key={tab.key}
                    title={tab.title}
                    className={`py-1 px-3 rounded fs-6 border-0 proposal-status w-auto ${
                      activeTab === tab.key
                        ? "text-white bg-purple fw-semibold"
                        : "text-purple"
                    }`}
                    onClick={() => setActiveTab(tab.key)}
                  >
                    {tab.label}
                    <span>: {tabData.length}</span>
                  </button>
                );
              })}
            </div>
          </div>
          {/* {!dashElement ? (
          ) : (
            <h4>Hosting</h4>
          )} */}
        </Col>
        <Col
          md={7}
          className="d-flex align-items-center justify-content-end pl-0"
        >
          <div>
            <select
              className="s me-4 form-select"
              style={{ width: "100px" }}
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
            >
              {[10, 25, 50, 100].map((size) => (
                <option key={size} value={size}>
                  Show {size}
                </option>
              ))}
            </select>
          </div>
          <div className="me-4 mt-10">
            <div className="search-box">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={(e) => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="s form-control rounded"
                    placeholder="Search..."
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div className="text-md-end">
            {!dashElement && (
              <>
                <Link
                  onClick={() => setModal(true)}
                  className="s btn text-white me-2 btn-save btn-label"
                >
                  <i className="fas fa-plus me-2 icon-size label-icon"></i>Add
                  Hosting
                </Link>
                <button
                  onClick={() => navigate(-1)}
                  className="s btn btn-red btn-label"
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  CANCEL
                </button>
              </>
            )}
          </div>
        </Col>
      </Row>
      <div className="position-relative">
        <CommonTable
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          prepareRow={prepareRow}
          nodataRecord={
            activeTab === "CURRENT"
              ? `No Hosting expiring in the current month`
              : "No Data Found"
          }
        />
      </div>

      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagination
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>

      <HostingModal
        modal={modal}
        setModal={setModal}
        locationOptions={locationOptions}
        customerOptions={customerOptions}
        projectOptions={projectOptions}
        packageOptions={packageOptions}
        setCustomerOption={setCustomerOption}
        setProjectOptions={setProjectOptions}
        allServicesOptions={allServicesOptions}
        hostingDurations={hostingDurations}
        handleSubmit={handleSubmit}
        location={location}
        setLocation={setLocation}
        customer={customer}
        setCustomer={setCustomer}
        project={project}
        setProject={setProject}
        Package={Package}
        setPackage={setPackage}
        services={services}
        setServices={setServices}
        isEdit={isEdit}
        setEdit={setEdit}
        isRenew={isRenew}
        setRenew={setRenew}
      />
    </>
  );
}

const HostingIndexPage2 = ({ dashElement = false }) => {
  const [modal, setModal] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [isRenew, setRenew] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [locationOptions, setLocationOption] = useState([]);
  const [customerOptions, setCustomerOption] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [packageOptions, setPackageOptions] = useState([]);
  const [allServicesOptions, setAllServicesOptions] = useState([]);
  const [hostingDurations, setHostingDurations] = useState([]);

  const [allCustomers, setAllCustomer] = useState([]);
  const [location, setLocation] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [project, setProject] = useState(null);
  const [Package, setPackage] = useState(null);
  const [services, setServices] = useState([]);

  const [viewModal, setViewModal] = useState(false);
  const [renewalLogs, setRenewalLogs] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [currencyOptions, setCurrencyOptions] = useState([]);

  // getting initial Datas
  useEffect(() => {
    (async () => {
      await getHostingData();
      await fetchProjectData();
      await getPackageData();
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const response = await fetchData(
        setLoading,
        "currency",
        secureLocalStorage?.getItem("auth_token"),
      );
      if (response?.success) {
        const options = response?.data?.currency?.map((c) => ({
          label: c.currency,
          value: c.currency,
          symbol: c.symbol,
        }));
        setCurrencyOptions(options);
      }
    })();
  }, []);

  const getHostingData = async () => {
    const response = await fetchNodeData(
      setLoading,
      "hostings",
      secureLocalStorage?.getItem("auth_token"),
    );

    if (response.success) {
      const datas = response.data?.map((item) => {
        if (item.package?.packageId == configure.hostingDomainOnlyId) {
          const services = JSON.parse(item.services || "[]");
          if (services?.length)
            item.domainName = services[0]?.description || "";
        }

        return item;
      });
      setData(datas);
      setAllData(datas);
    }
  };

  const fetchProjectData = async () => {
    try {
      const res = await fetchData(
        setLoading,
        "projectRelatedData",
        secureLocalStorage.getItem("auth_token"),
      );
      if (res?.success) {
        const { location, customer = [] } = res.data;
        const createOptions = (items, label, value) => {
          return items
            ?.filter((i) => i.id !== 2)
            ?.map((item) => ({ label: item?.[label], value: item?.[value] }));
        };
        //         const createOptions = (items, label, value) => {
        //   return items?.map(item => ({
        //     label: item?.[label],
        //     value: item?.[value],
        //   }))
        // }
        const locs = createOptions(location, "location", "id");
        setLocationOption(locs || []);
        setLocation(locs[0] || null);
        console.log("customer", customer);
        setAllCustomer(
          customer
            ?.filter((i) => i.trash == 0)
            ?.map((item) => ({
              label: item.company || "",
              value: item.id || "",
              location: item.location || "",
            })),
        );
      }
    } catch (error) {
      console.error("Error fetching project data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load project data. Please try again.",
      });
    }
  };

  const getPackageData = async () => {
    try {
      const packageResponse = await fetchNodeData(
        null,
        "hostingPackageOption",
        secureLocalStorage?.getItem("auth_token"),
      );

      if (packageResponse.success && packageResponse.data) {
        const packageOptions = packageResponse.data
          .filter((pkg) => pkg.trash === 0)
          .map((pkg) => ({
            value: pkg.id,
            label: pkg.package_name,
            services: pkg.services,
          }));
        setPackageOptions(packageOptions);
      } else {
        setPackageOptions([]);
        Swal.fire({
          icon: "warning",
          title: "No Packages",
          text: "No packages found.",
        });
      }

      const servicesResponse = await fetchNodeData(
        null,
        "hostingService/service/get",
        secureLocalStorage?.getItem("auth_token"),
      );

      if (servicesResponse.success && servicesResponse.data) {
        const servicesOptions = servicesResponse.data
          .filter((srv) => srv.trash === 0)
          .map((srv) => ({
            value: srv.id,
            label: srv.service_name,
            price: parseFloat(srv.price),
            service_box: srv.service_box,
          }));
        setAllServicesOptions(servicesOptions);
      }

      const durationResponse = await FetchNodePostData(
        null,
        "hostingOptions/duration",
        secureLocalStorage?.getItem("auth_token"),
        {},
      );

      if (durationResponse.data?.success && durationResponse.data?.data) {
        const durationOptions = durationResponse.data?.data
          ?.filter((srv) => srv.trash === 0)
          ?.map((srv) => ({
            value: srv.duration,
            label: `${srv.duration} ${srv.month_duration}`,
          }));

        console.log("durationOptions", durationOptions);
        setHostingDurations(durationOptions);
      }
    } catch (error) {
      console.error(
        "Error fetching package, duration, or services data:",
        error,
      );
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load data. Please try again.",
      });
    }
  };

  useEffect(() => {
    if (location?.value) {
      setCustomerOption(
        allCustomers.filter((item) => item.location == location.value),
      );
    }
  }, [location]);

  useEffect(() => {
    if (customer?.value) {
      fetchProjects(customer?.value);
    }
  }, [customer]);

  const fetchProjects = async (customerId) => {
    try {
      const response = await FetchNodePostData(
        setLoading,
        "hostingOptions/projects",
        secureLocalStorage?.getItem("auth_token"),
        { customer: customerId },
      );

      if (response.data.success) {
        const options = response.data.data
          ?.filter((item) => item.trash === 0)
          .map((item) => ({
            value: item.id,
            label: item.project_name,
          }));
        setProjectOptions(options);
        return options;
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      setProjectOptions([]);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load projects. Please try again.",
      });
    }
  };

  async function onViewPermission(data) {
    const response = await fetchNodeData(
      setLoading,
      `hostingRenewLogs/${data.id}`,
      secureLocalStorage?.getItem("auth_token"),
    );
    setViewData(data);
    setRenewalLogs(response.data);
    setViewModal(true);
  }

  async function onEditPermission(data) {
    setEdit(data.id);
    setLocation(locationOptions.find((item) => item.value == data.location));
    setCustomer(allCustomers.find((item) => item.value == data.customer_name));
    if (data.customer_name) {
      const projects = await fetchProjects(data.customer_name);
      setProject(projects?.find((item) => item.value == data.project_name));
    }
    setPackage(
      packageOptions?.find((item) => item.value == data?.package?.packageId),
    );
    console.log("dataaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa", data);
    setServices(JSON.parse(data.services));
    setModal(true);
  }

  function onRenewPermission(data) {
    onEditPermission(data);
    setRenew(true);
    setModal(true);
  }

  const totalPrice = useMemo(
    () => services?.reduce((acc, curr) => acc + (Number(curr.price) || 0), 0),
    [services],
  );

  const totalBase = useMemo(
    () =>
      services?.reduce((acc, curr) => acc + (Number(curr.basePrice) || 0), 0),
    [services],
  );

  // const handleSubmit = async (e, service_id, options = {}) => {
  //   if (e) e.preventDefault();

  //   console.log("Service Id", service_id);
  //   const { archiveOnly = false, revert = false, silent = false } = options;

  //   // If archiveOnly, skip all validations and just send archive
  //   if (archiveOnly) {
  //     const result = await Swal.fire({
  //       title: "Are you sure?",
  //       text: revert
  //         ? "This service will be activated."
  //         : "This service will be archived.",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonText: revert ? "Yes, activate it!" : "Yes, archive it!",
  //       cancelButtonText: "Cancel",
  //     });

  //     if (!result.isConfirmed) return;

  //     try {
  //       console.log("First IsEdit", isEdit);
  //       // prepare same submitData structure
  //       const postServices = services.map((s) => ({
  //         id: s.id,
  //         service: s.service,
  //         description: s.description,
  //         price: s.price,
  //         basePrice: s.basePrice,
  //         startDate: s.startDate,
  //         dueDate: s.dueDate,
  //         renewalDuration: s.renewalDuration,
  //         currency: s.currency,
  //         service_box: s.service_box,
  //         isPackageService: s.isPackageService,
  //         archived: archiveOnly
  //           ? s.id === service_id
  //             ? revert
  //               ? 0
  //               : 1
  //             : s.archived ?? 0
  //           : s.archived ?? 0,
  //       }));

  //       const submitData = {
  //         location_id: location?.value,
  //         customer_id: customer?.value,
  //         project_id: project ? project.value : null,
  //         package_id: Package?.value,
  //         services: JSON.stringify(postServices),
  //         total_price: totalPrice?.toFixed(2),
  //         total_base_price: totalBase?.toFixed(2),
  //         service_id,
  //         // archived: revert ? 0 : 1,
  //       };

  //       const response = await FetchNodePutData(
  //         setLoading,
  //         "hostingOperations/edit",
  //         isEdit,
  //         submitData,
  //       );

  //       if (response.data.success) {
  //         Swal.fire({
  //           icon: "success",
  //           // title: "Archived",
  //           // text: "Service archived successfully!",
  //           title: revert ? "Activated" : "Archived",
  //           text: revert
  //             ? "Service activated successfully!"
  //             : "Service archived successfully!",
  //         });
  //         setServices((prevServices) =>
  //           prevServices.map((srv) =>
  //             srv.id === service_id
  //               ? { ...srv, archived: revert ? 0 : 1 }
  //               : srv,
  //           ),
  //         );
  //         getHostingData(); // refresh table
  //       }
  //     } catch (error) {
  //       console.error("Error archiving service:", error);
  //       Swal.fire({
  //         icon: "error",
  //         title: "Error",
  //         text: "Failed to archive service. Please try again.",
  //       });
  //     }

  //     return; // skip the rest of handleSubmit
  //   }

  //   const submitDatasssss = {
  //     location_id: location?.value,
  //     customer_id: customer?.value,
  //     project_id: project ? project.value : null,
  //     package_id: Package?.value,
  //     services: JSON.stringify(services),
  //     total_price: totalPrice?.toFixed(2),
  //     total_base_price: totalBase?.toFixed(2),
  //     ...(service_id ? { service_id } : {}),
  //   };

  //   console.log("submitdata", submitDatasssss);

  //   if (
  //     !location?.value ||
  //     !customer?.value ||
  //     // !project?.value ||
  //     !Package?.value ||
  //     services?.some(
  //       (srv) =>
  //         !srv.service ||
  //         !srv.renewalDuration ||
  //         !srv.startDate ||
  //         (!srv.description && srv.service_box == "yes"),
  //     )
  //   ) {
  //     Swal.fire({
  //       icon: "warning",
  //       title: "Oops...",
  //       text: "Please fill all required fields, including service details!",
  //     });
  //     return;
  //   }

  //   const postServices = services.map((s) => ({
  //     id: s.id,
  //     service: s.service,
  //     description: s.description,
  //     price: s.price,
  //     basePrice: s.basePrice,
  //     startDate: s.startDate,
  //     dueDate: s.dueDate,
  //     renewalDuration: s.renewalDuration,
  //     currency: s.currency,
  //     service_box: s.service_box,
  //     isPackageService: s.isPackageService,
  //     archived: archiveOnly
  //       ? s.id === service_id
  //         ? revert
  //           ? 0
  //           : 1
  //         : s.archived ?? 0
  //       : s.archived ?? 0,
  //   }));

  //   const submitData = {
  //     location_id: location?.value,
  //     customer_id: customer?.value,
  //     project_id: project ? project.value : null,
  //     package_id: Package?.value,
  //     services: JSON.stringify(postServices),
  //     total_price: totalPrice?.toFixed(2),
  //     total_base_price: totalBase?.toFixed(2),
  //     // archived: 0,
  //     ...(service_id ? { service_id } : {}),
  //   };

  //   // Compute dynamic start/end date for renewal message
  //   const firstService = services.find((s) => s.id == service_id);

  //   // const startDateStr = firstService
  //   //   ? moment(firstService.startDate).format("DD-MM-YYYY")
  //   //   : "-"
  //   // const endDateStr = firstService
  //   //   ? moment(firstService.dueDate).format("DD-MM-YYYY")
  //   //   : "-"
  //   // const startDateStr = firstService?.startDate
  //   // const endDateStr = calculateDueDate(
  //   //   firstService?.startDate,
  //   //   firstService?.renewalDuration
  //   // )
  //   const startDateStr = firstService?.startDate
  //     ? moment(firstService.startDate).format("DD-MM-YYYY")
  //     : null;

  //   const endDateStr =
  //     firstService?.startDate && firstService?.renewalDuration
  //       ? moment(
  //           calculateDueDate(
  //             firstService.startDate,
  //             firstService.renewalDuration,
  //           ),
  //         ).format("DD-MM-YYYY")
  //       : null;

  //   const warningMsg = isRenew
  //     ? `${
  //         startDateStr
  //           ? `You want to renew this service from\n${startDateStr} to ${endDateStr}?`
  //           : "You really want to update?"
  //       }`
  //     : isEdit
  //     ? "You really want to update?"
  //     : "You really want to add?";

  //   swal({
  //     title: "Are you sure?",
  //     text: warningMsg,
  //     icon: "warning",
  //     buttons: true,
  //     dangerMode: true,
  //   }).then(async (willDelete) => {
  //     console.log("isEdit", isEdit);
  //     if (willDelete) {
  //       try {
  //         let response;
  //         if (isEdit || isRenew) {
  //           response = await FetchNodePutData(
  //             setLoading,
  //             "hostingOperations/edit",
  //             isEdit,
  //             submitData,
  //           );
  //         } else {
  //           response = await FetchNodePostData(
  //             setLoading,
  //             "hostingOperations/add",
  //             secureLocalStorage?.getItem("auth_token"),
  //             submitData,
  //           );
  //         }
  //         if (response.data.success) {
  //           Swal.fire({
  //             icon: "success",
  //             title: "Success",
  //             text: ` ${
  //               isRenew
  //                 ? `Service${startDateStr ? " Renewed" : "s updated"} `
  //                 : isEdit
  //                 ? "Hosting updated"
  //                 : "Hosting added"
  //             } successfully`,
  //           });

  //           setServices(postServices);

  //           if (!isRenew) setModal(false);
  //           getHostingData();
  //         }
  //       } catch (error) {
  //         console.error("Error in handleSubmit:", error);
  //         Swal.fire({
  //           icon: "error",
  //           title: "Error",
  //           text: "Failed to add hosting. Please try again.",
  //         });
  //       }
  //     }
  //   });
  // };

  const handleSubmit = async (e, service_id, options = {}) => {
    if (e) e.preventDefault();

    console.log("Service Id", service_id);
    const { archiveOnly = false, revert = false, silent = false } = options;

    // ─── ARCHIVE ONLY ───────────────────────────────────────────────────────────
    // No changes here — fully preserved
    if (archiveOnly) {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: revert
          ? "This service will be activated."
          : "This service will be archived.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: revert ? "Yes, activate it!" : "Yes, archive it!",
        cancelButtonText: "Cancel",
      });

      if (!result.isConfirmed) return;

      try {
        console.log("First IsEdit", isEdit);
        const postServices = services.map((s) => ({
          id: s.id,
          service: s.service,
          description: s.description,
          price: s.price,
          basePrice: s.basePrice,
          startDate: s.startDate,
          dueDate: s.dueDate,
          renewalDuration: s.renewalDuration,
          currency: s.currency,
          service_box: s.service_box,
          isPackageService: s.isPackageService,
          archived: archiveOnly
            ? s.id === service_id
              ? revert
                ? 0
                : 1
              : s.archived ?? 0
            : s.archived ?? 0,
        }));

        const submitData = {
          location_id: location?.value,
          customer_id: customer?.value,
          project_id: project ? project.value : null,
          package_id: Package?.value,
          services: JSON.stringify(postServices),
          total_price: totalPrice?.toFixed(2),
          total_base_price: totalBase?.toFixed(2),
          service_id,
        };

        const response = await FetchNodePutData(
          setLoading,
          "hostingOperations/edit",
          isEdit,
          submitData,
        );

        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: revert ? "Activated" : "Archived",
            text: revert
              ? "Service activated successfully!"
              : "Service archived successfully!",
          });
          setServices((prevServices) =>
            prevServices.map((srv) =>
              srv.id === service_id
                ? { ...srv, archived: revert ? 0 : 1 }
                : srv,
            ),
          );
          getHostingData();
        }
      } catch (error) {
        console.error("Error archiving service:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to archive service. Please try again.",
        });
      }

      return;
    }

    // ─── VALIDATION (applies to Add / Edit / Renew) ───────────────────────────
    const submitDatasssss = {
      location_id: location?.value,
      customer_id: customer?.value,
      project_id: project ? project.value : null,
      package_id: Package?.value,
      services: JSON.stringify(services),
      total_price: totalPrice?.toFixed(2),
      total_base_price: totalBase?.toFixed(2),
      ...(service_id ? { service_id } : {}),
    };

    console.log("submitdata", submitDatasssss);

    if (
      !location?.value ||
      !customer?.value ||
      !Package?.value ||
      services?.some(
        (srv) =>
          !srv.service ||
          !srv.renewalDuration ||
          !srv.startDate ||
          (!srv.description && srv.service_box == "yes"),
      )
    ) {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text: "Please fill all required fields, including service details!",
      });
      return;
    }

    const postServices = services.map((s) => ({
      id: s.id,
      service: s.service,
      description: s.description,
      price: s.price,
      basePrice: s.basePrice,
      startDate: s.startDate,
      dueDate: s.dueDate,
      renewalDuration: s.renewalDuration,
      currency: s.currency,
      service_box: s.service_box,
      isPackageService: s.isPackageService,
      archived: s.archived ?? 0,
    }));

    const submitData = {
      location_id: location?.value,
      customer_id: customer?.value,
      project_id: project ? project.value : null,
      package_id: Package?.value,
      services: JSON.stringify(postServices),
      total_price: totalPrice?.toFixed(2),
      total_base_price: totalBase?.toFixed(2),
      ...(service_id ? { service_id } : {}),
    };

    // ─── RENEW WITH silent=true (called in a multi-renew loop) ────────────────
    // Skip confirmation swal and skip success swal.
    // Just fire the API and return true/false so the caller knows if it succeeded.
    if (silent) {
      try {
        const response = await FetchNodePutData(
          setLoading,
          "hostingOperations/edit",
          isEdit,
          submitData,
        );

        if (response.data.success) {
          setServices(postServices);
          getHostingData();
          return true; // signal success to caller
        }
        return false;
      } catch (error) {
        console.error(
          "Error in silent renew for service_id:",
          service_id,
          error,
        );
        return false;
      }
    }

    // ─── ADD / EDIT / SINGLE RENEW ────────────────────────────────────────────
    // Fully preserved original flow with swal confirmation + success message
    const firstService = services.find((s) => s.id == service_id);

    const startDateStr = firstService?.startDate
      ? moment(firstService.startDate).format("DD-MM-YYYY")
      : null;

    const endDateStr =
      firstService?.startDate && firstService?.renewalDuration
        ? moment(
            calculateDueDate(
              firstService.startDate,
              firstService.renewalDuration,
            ),
          ).format("DD-MM-YYYY")
        : null;

    const warningMsg = isRenew
      ? `${
          startDateStr
            ? `You want to renew this service from\n${startDateStr} to ${endDateStr}?`
            : "You really want to update?"
        }`
      : isEdit
      ? "You really want to update?"
      : "You really want to add?";

    swal({
      title: "Are you sure?",
      text: warningMsg,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      console.log("isEdit", isEdit);
      if (willDelete) {
        try {
          let response;
          if (isEdit || isRenew) {
            response = await FetchNodePutData(
              setLoading,
              "hostingOperations/edit",
              isEdit,
              submitData,
            );
          } else {
            response = await FetchNodePostData(
              setLoading,
              "hostingOperations/add",
              secureLocalStorage?.getItem("auth_token"),
              submitData,
            );
          }

          if (response.data.success) {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: `${
                isRenew
                  ? `Service${startDateStr ? " Renewed" : "s updated"}`
                  : isEdit
                  ? "Hosting updated"
                  : "Hosting added"
              } successfully`,
            });

            setServices(postServices);

            if (!isRenew) setModal(false);
            getHostingData();
          }
        } catch (error) {
          console.error("Error in handleSubmit:", error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to add hosting. Please try again.",
          });
        }
      }
    });
  };

  const columns = useMemo(
    () =>
      hostingColumns(
        onViewPermission,
        onEditPermission,
        onRenewPermission,
        currencyOptions,
      ),
    [allCustomers, packageOptions],
  );

  return (
    <>
      {isLoading && <Loader />}
      <Row>
        <Col lg={12} className="p-0">
          <Card>
            <CardBody>
              <div className="responsive-table">
                <TableContainer
                  columns={columns}
                  allData={allData || []}
                  dataLength={7}
                  dueThisMonth={1}
                  locationOptions={locationOptions}
                  customerOptions={customerOptions}
                  projectOptions={projectOptions}
                  packageOptions={packageOptions}
                  setCustomerOption={setCustomerOption}
                  setProjectOptions={setProjectOptions}
                  allServicesOptions={allServicesOptions}
                  hostingDurations={hostingDurations}
                  handleSubmit={handleSubmit}
                  location={location}
                  setLocation={setLocation}
                  customer={customer}
                  setCustomer={setCustomer}
                  project={project}
                  setProject={setProject}
                  Package={Package}
                  setPackage={setPackage}
                  services={services}
                  setServices={setServices}
                  modal={modal}
                  setModal={setModal}
                  isEdit={isEdit}
                  setEdit={setEdit}
                  isRenew={isRenew}
                  setRenew={setRenew}
                  dashElement={dashElement}
                />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Modal
        isOpen={viewModal}
        toggle={() => setViewModal(false)}
        size="xl"
        centered
        style={{ maxWidth: "95vw", width: "95vw" }}
      >
        <ModalHeader
          toggle={() => {
            setViewModal(false);
            setViewData(null);
          }}
          className="text-purple"
        >
          Hosting Renewal Logs:{" "}
          <span className="text-primary fw-bold">
            {viewData ? viewData.customer : "Unknown Project"}
          </span>
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              height: "70vh",
              overflow: "auto",
              scrollbarWidth: "thin",
              position: "relative",
            }}
          >
            <Table bordered hover striped>
              <thead className="bg-light position-sticky top-0 left-0 right-0 w-100">
                <tr>
                  <th className="text-center">Sr. No</th>
                  <th className="text-center">Package</th>
                  <th className="text-center">Package Price</th>
                  <th className="text-center">Service</th>
                  <th className="text-center">Start Date</th>
                  <th className="text-center">Due Date</th>
                  <th className="text-center">Renewed On</th>
                  <th className="text-center">Renewal Duration</th>
                </tr>
              </thead>
              <tbody>
                {renewalLogs.length ? (
                  renewalLogs.map((log, index) => (
                    <tr key={log.id}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">{log.package_name}</td>
                      <td className="text-center">
                        {log.price
                          ? log.price
                              .split(",")
                              .map(Number)
                              .reduce((a, b) => a + b, 0)
                          : 0}
                      </td>
                      <td className="text-center">{log.service}</td>
                      <td className="text-center">
                        {moment(log.start_date).format("DD-MM-YYYY")}
                      </td>
                      <td className="text-center">
                        {moment(log.due_date).format("DD-MM-YYYY")}
                      </td>
                      <td className="text-center">
                        {log.renew_date
                          ? moment(log.renew_date).format("DD-MM-YYYY")
                          : "--"}
                      </td>
                      <td className="text-center">
                        {log.renew_duration || "--"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="text-center">
                    <td colSpan={8}>No Renewal Logs Found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default HostingIndexPage2;
